import { displayLatLonInCompassFormat } from '@deckee/utilities';
import React from 'react';
import { pipes } from '../../../components/shared/vector-images';
import Text from '../../../components/shared/_deprecated/elements/Text/Text';
import {
  onInitializeStandardMarker,
  onToggleStandardMarker,
} from '../_helpers';

const layer = {
  displayName: 'Pump out',
  synonyms: '',
  group: 'standardMarker',
  typeUrl: 'pump-out',
  icon: {
    baseShape: pipes,
    iconColor: '#fff',
    markerColor: '#56AC5C',
  },
  shownByDefault: true,
  relativeDepth: 0,
  menuOptions: {
    visible: true,
    owningMenu: 'marine-facilities',
    order: 1000,
  },
  standardMarkerOptions: {
    markerType: 'pumpOutMarker',
    allowCreation: true,
    allowEditing: false,
    allowComments: true,
    viewOptions: {
      typeTitle: 'Pump out',
      itemTitleFunction: (item) => (item && item.title) || 'Pump out',
    },
    creationOptions: {
      menuText: 'Pump out',
      newTitle: 'Pump out location',
      titlePlaceholder: 'Name of pump out facility',
      markerTypeDescription: [
        <Text key="description-text-1" size="-1" paragraph>
          This marker indicates a place which provides a pump out facility for
          septic tanks.
        </Text>,
        <Text key="description-text-2" size="-1" paragraph>
          Information provided should be factual. Once you submit this marker,
          you can add your personal experiences or questions as a comment
          underneath.
        </Text>,
      ],
      checkBoxItems: [],
    },
    editingOptions: {},
  },
  popOverConfiguration: (marker) => ({
    markerType: layer.standardMarkerOptions.markerType,
    id: marker.id,
    displayChat: true,
    displayUpVotes: true,
    title: 'Pump out facility',
    description: displayLatLonInCompassFormat(marker.latLon),
  }),
};

layer.onInitialize = onInitializeStandardMarker(layer);
layer.onToggle = onToggleStandardMarker(layer);

export default layer;
